import React from 'react';
import PropTypes from 'prop-types';

const TransactionStatus = ({status = ``}) => {

  if (status === 'SUCCESS') {
    return <i className='fa  fa-check-circle-o fa_green fa-lg'/>
  }

  if (status === 'ERROR') {
    return <i className='fa fa-warning fa_red fa-lg'/>
  }

  return <i className='fa fa-refresh fa_yellow fa-lg'/>
};

TransactionStatus.propTypes = {
  status: PropTypes.string
};

export default TransactionStatus;



// WEBPACK FOOTER //
// ./src/transaction/component/TransactionStatus.js